import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 103BB26D-356A-4F6D-9F98-787CEC908FAD
 * name bulma
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bulma.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const BulmaIcon = createSvgIcon(<><path d="M11.38 2L6.38 7L5.13 15.75L11.38 22L18.88 17L13.88 12L17.63 8.25L11.38 2Z" /></>, 'BulmaIcon');
export default BulmaIcon